exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "aside.boxCountDown section div.countDown>section[data-v-6e72f791]{text-align:center}aside.boxCountDown section div.countDown>section>p[data-v-6e72f791]{margin-bottom:0}aside.boxCountDown section div.countDown>section.block-digit>p[data-v-6e72f791]{color:var(--color-second);background:var(--color-first);font-size:larger;font-weight:700;text-align:center}aside.boxCountDown section div.countDown>section.block-text>p[data-v-6e72f791]{background:var(--color-second);color:var(--color-first);font-size:larger;font-weight:700;text-align:center}aside.boxCountDown div.form-floating>textarea.form-control[data-v-6e72f791]{border-radius:.8rem;height:3rem;padding-top:1.25rem}aside.boxCountDown div.form-floating>label[data-v-6e72f791]{padding-top:.7rem;color:var(--color-first)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6e72f791","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/shared/CountDown.vue
// module id = 441
// module chunks = 10